import { ModelRow } from "@mcleod/core";
import { SecondaryFilterProps } from "@mcleod/dispatch";

export class MiscInvoiceProcessingSecondaryFilter {
    static readonly FILTER_RECURRING: SecondaryFilterProps = {
        id: "recurringInvoices",
        caption: "Recurring",
        filter: (row: ModelRow) => !row.isNull("ar_cycle_code_id")
    };

    static readonly FILTER_NON_RECURRING: SecondaryFilterProps = {
        id: "nonRecurringInvoices",
        caption: "Non-Recurring",
        filter: (row: ModelRow) => row.isNull("ar_cycle_code_id")
    };
}
